import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';
import { IconTypes } from '@eika/icon';

import type { Account, AccountNumber } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import ErrorCard from '../errorcard/ErrorCard';
import { SelectList } from '../shared/SelectList';
import AccountListItem from './AccountListItem';
import AccountsEmptyInfo from './AccountsEmptyInfo';

export interface AccountListProps {
    accounts?: Account[];
    retry: () => void;
    error?: RequestExceptionWithResponse;
    selectedAccount?: { number: AccountNumber; status: 'loading' | 'success' | null };
    onClick: (newAccountNumber: AccountNumber) => void;
    showNegativeAmount?: boolean;
    inactive?: boolean;
}

const AccountList: React.FC<AccountListProps> = ({
    accounts,
    selectedAccount,
    retry,
    error,
    onClick,
    inactive,
    showNegativeAmount = false,
}) => {
    const translated = useTranslation();
    if (error) {
        return (
            <ErrorCard
                isModal
                title={translated.errors.ohNo}
                exception={error}
                description={translated.accountsList.errorMessage}
                icon={IconTypes.BANDAGED_HEART}
            >
                <Button onClick={retry}>{translated.tryAgain}</Button>
            </ErrorCard>
        );
    }
    if (accounts && accounts.length > 0) {
        return (
            <SelectList>
                {accounts.map((currentAccount) => {
                    const status =
                        currentAccount.accountNumber.value === selectedAccount?.number.value
                            ? selectedAccount.status
                            : null;
                    return (
                        <li key={currentAccount.accountId.value}>
                            <AccountListItem
                                isLoading={status === 'loading'}
                                isSuccess={status === 'success'}
                                inactive={inactive}
                                account={currentAccount}
                                onClick={() => onClick(currentAccount.accountNumber)}
                                showNegativeAmount={showNegativeAmount}
                            />
                        </li>
                    );
                })}
            </SelectList>
        );
    }

    return <AccountsEmptyInfo />;
};

export default AccountList;
